module.exports = __webpack_public_path__ + "static/img/home_black.56ba8263.svg";